import { useTranslate } from 'react-admin';
import { IconButton, useTheme, useMediaQuery, Box, Typography, Tooltip } from '@mui/material';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { serviceRequestStatusChoices } from '@/components/global/options/selectOptions.jsx';
import ServiceProgressIcon from '@/assets/icons/service-progress-icon.svg?react';
import ServiceNewIcon from '@/assets/icons/service-new-icon.svg?react';
import ServiceFailedIcon from '@/assets/icons/service-failed-icon.svg?react';
import ArrowRightSmallIcon from '@/assets/icons/arrow-right-small-icon.svg?react';
import { formatTimePassed } from '@/helpers/date/formatTimePassed.js';
import { format } from 'date-fns';

const StyledServiceRequestStatusField = styled('div')(({ theme }) => ({
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    padding: '12px 0 0',
    fontSize: '11px',
    [theme.breakpoints.up('lg')]: {
        flexWrap: 'nowrap',
        padding: 0,
        fontSize: '14px',
    },
    '& .service-request-status-field-icon': {
        marginRight: '8px',
        height: '20px',
    },
    '& .service-request-status-field-info': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'left',
        [theme.breakpoints.up('lg')]: {
            flexDirection: 'column',
            alignItems: 'flex-start',
            fontSize: '14px',
        },
    },
    '& .service-request-status-field-info-name': {
        [theme.breakpoints.up('lg')]: {
            whiteSpace: 'nowrap',
        },
    },
    '& .service-request-status-field-info-time': {
        fontSize: '11px !important',
        whiteSpace: 'nowrap',
    },
}));

export const ServiceRequestStatusField = ({ record, handleClick }) => {
    const translate = useTranslate();
    const theme = useTheme();
    const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.values.lg}px)`);
    if (!record) return null;

    const status = serviceRequestStatusChoices(translate).find(s => s.id === record.status) || {
        name: translate('resources.device.fields.notSpecified') || '',
    };
    let icon = <ServiceProgressIcon />;
    if (record.status === 'new') {
        icon = <ServiceNewIcon />;
    } else if (record.status === 'failedContact') {
        icon = <ServiceFailedIcon />;
    }

    return (
        <StyledServiceRequestStatusField>
            <Box className='service-request-status-field-icon'>{icon}</Box>
            <Box className='service-request-status-field-info'>
                <Typography className='service-request-status-field-info-name'>
                    {status.name}
                    {isMobile ? ' - ' : ''}
                </Typography>
                <Tooltip title={record.updatedAt ? format(new Date(record.updatedAt), 'dd.MM.yyyy HH:mm') : ''} arrow classes={{ tooltip: 'tooltip-black' }}>
                    <Typography className='service-request-status-field-info-time'>{formatTimePassed(record.updatedAt, translate)}</Typography>
                </Tooltip>
            </Box>
            <IconButton className='toggle-drawer-button' onClick={handleClick}>
                <ArrowRightSmallIcon />
            </IconButton>
        </StyledServiceRequestStatusField>
    );
};

ServiceRequestStatusField.propTypes = {
    record: PropTypes.shape({
        status: PropTypes.string,
        updatedAt: PropTypes.string,
    }),
    handleClick: PropTypes.func,
};
